import React from 'react';
import Modal from "../display/Modal";
import { methodCallFromString, omit } from "../../modules/utils";
import { trackEvent } from "../../modules/tracking";
import { resolveTrackingEventKey } from "../../modules/analyticsEvents";
export default function ActionsModal({ id, title, body, displayed, onClose, actions }) {
    const handleOnClick = (e, action) => {
        e.preventDefault(); // If the action is a method, call it
        const actionOnClick = methodCallFromString(action.onClick);
        if (typeof actionOnClick !== 'undefined' && actionOnClick !== false) {
            actionOnClick(e);
        } // `action.trackingEvent` is a server-rendered KEY (from the Rails view
        // config, e.g. _contact_modal.html.erb) resolved against the
        // AnalyticsEvents catalog below, rather than a raw event name string -
        // this keeps every value passed to trackEvent() catalog-sourced.
        const resolvedEvent = resolveTrackingEventKey(action.trackingEvent);
        if (resolvedEvent) {
            trackEvent(resolvedEvent).then(() => {
                if (action.target) {
                    window.open(action.href, action.target);
                    return;
                }
                window.location.href = action.href;
            });
        }
        else {
            window.location.href = action.href;
        }
    };
    const renderFooter = () => { if (!actions || !actions.length)
        return null; return /*#__PURE__*/ React.createElement("footer", { className: "actions-modal__footer" }, actions.map((action, index) => /*#__PURE__*/ React.createElement("a", Object.assign({ className: "actions-modal__action", key: `a-${index}`, onClick: e => handleOnClick(e, action) }, omit(action, ['onClick', 'trackingEvent'])), /*#__PURE__*/ React.createElement("span", { className: "actions-modal__action__text" }, action.label)))); };
    return /*#__PURE__*/ React.createElement(Modal, { id: id, onClose: onClose, classNames: 'actions-modal', displayed: displayed }, title && /*#__PURE__*/ React.createElement("header", { className: "actions-modal__header" }, /*#__PURE__*/ React.createElement("h2", { className: "actions-modal__title" }, title)), /*#__PURE__*/ React.createElement("div", { className: "actions-modal__body", dangerouslySetInnerHTML: { __html: body } }), renderFooter());
}
